import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {
	DeleteBatchRefundProcedure,
	DeleteBatchRefundProcedureParams,
} from 'domain/usecases/private/refund/request/delete-batch-procedure';
import {RemoteRefundDeleteBatchProcedure} from 'data/usecases/private/refund/request/remote-delete-batch-procedure';
import {RefundFlowEndPoints} from '../../../endpoints';

export const makeDeleteBatchRefundProcedure = (
	params: DeleteBatchRefundProcedureParams,
): DeleteBatchRefundProcedure =>
	new RemoteRefundDeleteBatchProcedure(
		makeBFFApiUrl(
			`${RefundFlowEndPoints.protocols}/${params.protocolCode}/requests/${params.requestCode}/procedure/${params.procedureCode}`,
		),
		makeAuthorizeHttpClientDecorator(),
	);
